export default __webpack_public_path__ + "static/media/questions.fb8df119.png";